import React, { createContext, useContext, useMemo } from "react";

const BasePathContext = createContext<string>("");

interface BasePathProviderProps {
  basePath: string;
  children: React.ReactNode;
}

export function BasePathProvider({ basePath, children }: BasePathProviderProps) {
  return (
    <BasePathContext.Provider value={basePath}>
      {children}
    </BasePathContext.Provider>
  );
}

export function useBasePath() {
  const basePath = useContext(BasePathContext);

  return useMemo(() => ({
    basePath,
    /** Prepend basePath to a route: appPath("/editor") → "/app/editor" or "/editor" */
    appPath: (route: string) => basePath + route,
    /** Strip basePath from a pathname for matching: "/app/editor" → "/editor" */
    stripBase: (pathname: string) =>
      basePath && pathname.startsWith(basePath)
        ? pathname.slice(basePath.length) || "/"
        : pathname,
  }), [basePath]);
}
